function cx(...arr) {
  return arr.join(' ');
}

export default cx;
